export default __webpack_public_path__ + "static/media/Bryggerilagret_Logga_png.f10942ee.png";